import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { getABOImageAPI, partyId, retrieveImageByUrlAPI, userId } from '../../shared/constants/end-point-constants';
import { UserImage } from '../../shared/models/user-image.model';
import { ApiConfigService } from '../api-config/api-config.service';
import { HttpHandlerService } from '../http-handler/http-handler.service';

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {
    constructor(private httpService: HttpHandlerService,
        private sanitizer: DomSanitizer,
        private apiPathService: ApiConfigService) { }

    /**
     *
     *
     * @name retrieveABOImage
     * @description this method is used to retrieve image url
     * @param abonum, partyid
     * @returns Returns an observable
     * @memberof UserProfileService
     */
    retrieveABOImage(abonum: string, partyid: string): Observable<UserImage> {
        return new Observable<UserImage>(observer => {
            this.getABOImageInfo(abonum, partyid).subscribe(
                url => {
                    if (url) {
                        this.getImageByUrl(url, abonum, partyid).subscribe(img => {
                            observer.next(img);
                            observer.complete();
                        });
                    } else {
                        observer.next({ url: '' });
                        observer.complete();
                    }
                },
                error => {
                    observer.next({ url: '' });
                    observer.complete();
                }
            );
        });
    }

    /**
     *
     *
     * @name getABOImageInfo
     * @description this method is used to get abo user image
     * @param abonum, partyid
     * @returns Returns an observable
     * @memberof UserProfileService
     */
    private getABOImageInfo(abonum: string, partyid: string): Observable<string> {
        return new Observable<string>(observer => {
            const api = this.apiPathService.getAPIPath(getABOImageAPI);
            api.path = api.path
                .replace(userId, environment.affiliateCode + '-' + abonum)
                .replace(partyId, partyid);
            this.httpService.callServerGET(api, null).subscribe(
                (response: { imageList: [{ imageRefUrl: string }] }) => {
                    const imgUrl =
                        response && response.imageList && response.imageList.length
                            ? response.imageList[0].imageRefUrl
                            : '';
                    observer.next(imgUrl);
                    observer.complete();
                },
                err => {
                    observer.next('');
                    observer.complete();
                }
            );
        });
    }

    /**
     *
     *
     * @name getImageByUrl
     * @description this method is used to retrieve image url
     * @param url, abonum, partyid
     * @returns Returns an observable
     * @memberof UserProfileService
     */
    private getImageByUrl(imageurl: string, abonum: string, partyid: string): Observable<UserImage> {
        const api = this.apiPathService.getAPIPath(retrieveImageByUrlAPI);
        api.path = api.path
            .replace(userId, environment.affiliateCode + '-' + abonum)
            .replace(partyId, partyid);
        const urlParams = new HttpParams().set('imageRefUrl', imageurl);
        return new Observable<UserImage>(observer => {
            let url: SafeResourceUrl = '';
            this.httpService
                .callServerGET(api, urlParams, null, 'blob').pipe(finalize(() => {
                    observer.next({ url });
                    observer.complete();
                }))
                .subscribe(response => {
                    if (response && response instanceof Blob) {
                        url = this.sanitizer.bypassSecurityTrustResourceUrl(
                            window.URL.createObjectURL(response)
                        );
                    }
                });
        });
    }
}
